<template>
  <button
    class="m-thumbnail"

    aria-hidden="true"

    :style="!image ? {} : {
      backgroundImage: `url(${image})`,
    }"
  >
    <span class="m-thumbnail__inner" />
  </button>
</template>

<script>
// Export
export default {
  name: `module-thumbnail`,

  // Props
  props: {
    image: String,
    required: true,
  },
};
</script>



// WEBPACK FOOTER //
// Thumbnail.vue?7677779b